import {IErrorEvent} from '../../../api/network';
import {api} from '../../../api/proto';
import i18n from '../../../i18n';

export default function getCreateUserTagError(error?: IErrorEvent | null, res?: api.IUserCreateTagResponse | null): string | null {
  if (error) {
    return error.message || 'Unknown error';
  }

  switch (res?.status) {
    case api.UserCreateTagResponse.Status.UAT_INTERNAL_ERROR:
      return i18n.t('tags_create_user_tag_internal_error');
    case api.UserCreateTagResponse.Status.UAT_ALREADY_ADDED:
      return i18n.t('tags_create_user_tag_already_added');
  }

  return null;
}
